const translation = {
    PageSize: 'Tamaño de página',
    PageOrientation: 'Orientación de página',
    Format: 'Formato',
    DPI: 'DPI',
    Title: 'Exportar mapa',
    Close: 'Cerrar',
    Save: 'Guardar',
    FileName: 'Nombre del archivo',
    Landscape: 'Horizontal',
    Portrait: 'Vertical',
    PreviewHint: 'Ajusta el área a exportar en el mapa.',
    ExportFailed: 'No se pudo exportar el mapa. Inténtalo de nuevo.',
    PreviewFailed: 'No se pudo generar la vista previa.',
    AdjustArea: 'Ajustar el área en el mapa',
    AdjustAreaHint: 'Mueve, haz zoom, gira o inclina el mapa para encuadrar el área a exportar',
    ZoomIn: 'Acercar',
    ZoomOut: 'Alejar',
    ResetZoom: 'Restablecer el zoom al 100 %',
    Done: 'Listo',
    Cancel: 'Cancelar',
    Scalebar: 'Barra de escala',
    NorthIcon: 'Icono del norte',
    ChooseNorthIcon: 'Elegir el icono del norte',
    ChooseSvgFile: 'Elegir un archivo SVG',
    IconSymbol: 'Símbolo del icono',
    IconColor: 'Color del icono',
    IconSize: 'Tamaño del icono',
    InvalidSvg: 'El archivo no es un SVG válido.',
    ExportAsVector: 'Exportar como vector',
    ExportLabelsAsVector: 'Exportar etiquetas como vector',
    Custom: 'Personalizado',
    Width: 'Ancho',
    Height: 'Alto',
    LanguageName: 'Española',
    LanguageCode: 'es'
};
export default translation;
